module.exports = "/assets/data/a76ac1f468a564a92e3fe6a784aefaec-DL3.data.json";